import { getAdminInvoicingRunsRetrieveQueryOptions } from "@sidegigllc/api/client";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { runId: number };

export const runQuery = ({ runId }: QueriesInput) =>
  getAdminInvoicingRunsRetrieveQueryOptions(runId, { query: { enabled: runId > 0 } });

export const queries = (input: QueriesInput): Array<WarmableQuery> => [runQuery(input)];
